import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from "react";
import {
  Alert,
  Modal,
  Form,
  Button,
  Row,
  Col,
  Card,
  Spinner,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import toastr from "toastr";
import {
  getRelatives,
  saveRelatives,
  editRelatives,
  deleteRelatives,
} from "../../redux/relatives/actions";
import { getRelationShip } from "../../redux/relationship/actions";
import { requestChangesDependants } from "../../redux/updateDependantsData/actions";
import messages from "../../redux/messages";
import CustomTable from "../../components/CustomTable";
import config from "../../config";
import { getSubNiveles } from "../../redux/gestorDocumental/actions";
import { getBase64 } from "../../components/gestorDocumental/GestorDocumental";
// import toastr from "toastr";
import LinkDescargaListGD from "../../components/gestorDocumental/LinkDescargaListGD";
import LinkDescargaGD from "../gestorDocumental/LinkDescargaGD";

const DependentRelativesComponent = (props, ref) => {
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  // const [fileTemp, setFileTemp] = useState("");

  const [validFechaDoc, setValidFechaDoc] = useState(false);
  const [habilitarFecha, setHabilitarFecha] = useState(false);

  //Redux
  const dispatch = useDispatch();
  //EmerContact
  const loading = useSelector((store) => store.relatives.loading);
  const data = useSelector((store) => store.relatives.relatives);
  const saveRelativesLoader = useSelector(
    (store) => store.relatives.saveLoader
  );
  //RelationShip
  const relationShip = useSelector((store) => store.relationship.relationShip);
  const relationShipLoader = useSelector((store) => store.relationship.loading);
  // const userInfo = useSelector((store) => store.employees.employee);
  const userId = useSelector((store) => store.auth.id);
  const userN = useSelector((store) => store.auth.username);

  //auth
  const userOrg = useSelector((store) => store.auth.userOrg);

  const {
    // areas,
    // carpetas,
    // docs,
    subNiveles,
    areasError,
    carpetasError,
    error,
    formErrors,
    loaderSubNiveles,
    loadingDocs,
    loadingAreas,
    loadingCarpetas,
    saveDocsLoading,
    subNivelesError,
  } = useSelector((store) => store.gestorDocumental);

  const { carpeta, tipoDocumentoGD, tipoDocumento } =
    config.gestorDocumental.familiaresDependientes;
  const { area, email } = config.gestorDocumental;

  const columns = [
    {
      Header: "Identidad",
      accessor: "identidad",
    },
    {
      Header: "Nombre",
      accessor: "nombre",
    },
    {
      Header: "Primer apellido",
      accessor: "primer_apellido",
      Filter: "",
    },
    {
      Header: "Segundo apellido",
      accessor: "segundo_apellido",
      Filter: "",
    },
    {
      Header: "Teléfono",
      accessor: "telefono",
      Filter: "",
    },
    {
      Header: "Fecha de nacimiento",
      Filter: "",
      Cell: (value) =>
        moment(value.row.original.fecha_nacimiento).format("DD/MM/YYYY"),
    },
    {
      Header: "Parentesco",
      Filter: "",
      Cell: (value) => {
        const parent = relationShip.find(
          (item) => item.id === parseInt(value.row.original.parentesco)
        );
        return parent ? parent.nombre : "";
      },
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group d-flex align-items-center" role="group">
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Editar el registro</Tooltip>}
          >
            <Button
              size="sm"
              variant="link"
              type="button"
              disabled={loaderSubNiveles}
              onClick={() => onEdit(value.row.original, value.row.index)}
            >
              <i className="material-icons">edit</i>
            </Button>
          </OverlayTrigger>
          {loaderSubNiveles ? (
            <Spinner
              className="mr-2"
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          ) : null}
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Eliminar el registro</Tooltip>}
          >
            <Button
              size="sm"
              className="text-danger"
              variant="link"
              type="button"
              disabled={props.dpt === 2}
              onClick={() => onDelete(value.row.original.id, value.row.index)}
            >
              <i className="material-icons">close</i>
            </Button>
          </OverlayTrigger>
          {value.row.original.archivo_gestor && (
            <LinkDescargaListGD
              id={value.row.original.id}
              filters={{
                email: email,
                id: value.row.original.archivo_gestor[0].id_documento,
                llave: value.row.original.archivo_gestor[0].llave,
              }}
              origen={value.row.original.archivo_gestor[0].origen}
              icono={<i className="material-icons">file</i>}
              cType={value.row.original.archivo_gestor[0].contentTypeGD}
            />
          )}
        </div>
      ),
    },
  ];

  const onAdd = () => {
    const oCarpeta = props.carpetas.find(
      (item) => item.descripcion.toLowerCase() === carpeta.toLowerCase()
    );
    dispatch(
      getSubNiveles({
        areaid: props.areas[0].id,
        ceid: oCarpeta.id,
      })
    );

    setHabilitarFecha(false);
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  useImperativeHandle(ref, () => ({
    onAdd,
  }));

  const onEdit = (item, index) => {
    const oCarpeta = props.carpetas.find(
      (item) => item.descripcion.toLowerCase() === carpeta.toLowerCase()
    );
    dispatch(
      getSubNiveles({
        areaid: props.areas[0].id,
        ceid: oCarpeta.id,
      })
    );

    setHabilitarFecha(false);
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  useEffect(() => {
    dispatch(
      getRelatives(
        {
          filter: props.id,
          empleado: props.id,
        },
        parseInt(props.type)
      )
    );
  }, [dispatch, props.id, props.type]);

  useEffect(() => {
    if (!saveDocsLoading) {
      dispatch(
        getRelatives(
          {
            filter: props.id,
            empleado: props.id,
          },
          parseInt(props.type)
        )
      );
    }
  }, [saveDocsLoading]);

  useEffect(() => {
    dispatch(getRelationShip(parseInt(props.type)));
  }, [dispatch, props.type]);

  const onSubmitAdmin = async (e) => {
    e.preventDefault();
    debugger;
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }
    if (e.target.documentos.files.length === 0 ){
      toastr.error('Debe ingresar un documento');
      return;
    }
    let isValidFilePreData = true;
    let exist = e.target.documentos.files.length > 0;
    if (exist && e.target.fechaDoc.value === "") {
      isValidFilePreData = false;
    }

    if (props.areas.length === 0 || props.carpetas === 0) {
      isValidFilePreData = false;
    }

    if (!isValidFilePreData) {
      setValidFechaDoc(true);
      setValidated(true);
      return;
    }

    let depend = new FormData();

    if (exist) {
      try {
        const oArea = props.areas.find(
          (item) => item.descripcion.toLowerCase() === area.toLowerCase()
        );
        const oCarpeta = props.carpetas.find(
          (item) => item.descripcion.toLowerCase() === carpeta.toLowerCase()
        );
        const filebase64 = await getBase64(e.target.documentos.files[0]);
        const fileName = e.target.documentos.files[0].name;
        const fName = String(fileName)
          .substring(0, String(fileName).lastIndexOf("."))
          .replace(/\W/g, "");
        const fExt = `.${String(fileName).substr(
          fileName.lastIndexOf(".") + 1 - fileName.length
        )}`;
        const aFileBase = String(filebase64).split(",");

        depend.append("id_empleado", parseInt(props.id));
        depend.append("tipo_documento", tipoDocumento);
        depend.append("archivo", aFileBase[1]);
        depend.append("contentTypeGD", `${aFileBase[0]},`);
        depend.append("origen", fName + fExt);
        depend.append("extension", fExt);
        depend.append("descripcion", e.target.documentDesc.value);
        depend.append(
          "fecha",
          moment(e.target.fechaDoc.value).format("YYYY-MM-DD")
        );
        depend.append("id_area", oArea && oArea.id ? oArea.id : null);
        depend.append(
          "id_carpeta_encabezado",
          oCarpeta && oCarpeta.id ? oCarpeta.id : null
        );
        depend.append("empresa", props.userInfo.empresa[0]);
        depend.append(
          "zona",
          props.userInfo.Division_Personal_List[0].descripcion
        );
        depend.append("tipo_documento_GD", tipoDocumentoGD);
      } catch (error) {
        console.log(error);
        toastr.info("Error al subir archivo");
      }
    }
    
   



    const oData = {
      nombre: e.target.relativeName.value,
      primer_apellido: e.target.primer_apellido.value,
      segundo_apellido: e.target.segundo_apellido.value,
      apellido_soltera: e.target.apellidoSolt.value,
      identidad: e.target.relativeNIdentidad.value,
      subtipo: relationShip.find(
        (item) => item.id === parseInt(e.target.relativeRelationShip.value)
      ).codigo,
      de: moment().format("YYYY-MM-DD"),
      hasta: moment().format("YYYY-MM-DD"),
      fecha_nacimiento: e.target.relativeBday.value,
      secuencia: edit ? editItem.secuencia : "",
      ciudad_nacimiento: e.target.lugarnaci.value,
      pais_nacimiento: e.target.countyofbirt.value,
      nacionalidad: e.target.countyofbirt.value,
      dependiente: e.target.esDep.checked ? "X" : "",
      genero: e.target.relativeGender.value,
      empleado: parseInt(props.id),
      direccion: e.target.dependentRelativesAddress.value,
      telefono: e.target.cel.value,
      anotaciones: e.target.obs.value,
      parentesco: e.target.relativeRelationShip.value,
    };
    if (edit) {
      depend.append("id_registro", parseInt(editItem.id));
      dispatch(
        editRelatives(
          oData,
          editItem.id,
          index,
          parseInt(props.type),
          depend,
          editItem.archivos_gestor,
          exist,
          setShowModal,
          setValidFechaDoc
        )
      );
    } else {
      dispatch(
        saveRelatives(
          oData,
          parseInt(props.type),
          depend,
          exist,
          setShowModal,
          setValidFechaDoc,
          e.target
        )
      );
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    debugger;
    
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    if (edit && e.target.documentos.files.length === 0 ){
      toastr.error('Debe ingresar un documento');
      return;
    }

    let exist = edit ? e.target.documentos.files.length > 0 : false;

    if (edit) {
      let isValidFilePreData = true;
      if (
        e.target.documentos.files.length > 0 &&
        e.target.fechaDoc.value === ""
      ) {
        isValidFilePreData = false;
      }

      if (props.areas.length === 0 || props.carpetas === 0) {
        isValidFilePreData = false;
      }

      if (!isValidFilePreData) {
        setValidFechaDoc(true);
        setValidated(true);
        return;
      }
    }

    let depend = new FormData();

    if (edit) {
      const oArea = props.areas.find(
        (item) => item.descripcion.toLowerCase() === area.toLowerCase()
      );
      const oCarpeta = props.carpetas.find(
        (item) => item.descripcion.toLowerCase() === carpeta.toLowerCase()
      );

      try {
        const filebase64 = await getBase64(e.target.documentos.files[0]);
        const fileName = e.target.documentos.files[0].name;
        const fName = String(fileName)
          .substring(0, String(fileName).lastIndexOf("."))
          .replace(/\W/g, "");
        const fExt = `.${String(fileName).substr(
          fileName.lastIndexOf(".") + 1 - fileName.length
        )}`;
        const aFileBase = String(filebase64).split(",");

        depend.append("id_empleado", parseInt(props.id));
        depend.append("tipo_documento", tipoDocumento);
        depend.append("archivo", aFileBase[1]);
        depend.append("contentTypeGD", `${aFileBase[0]},`);
        depend.append("origen", fName + fExt);
        depend.append("extension", fExt);
        depend.append("descripcion", e.target.documentDesc.value);
        depend.append(
          "fecha",
          moment(e.target.fechaDoc.value).format("YYYY-MM-DD")
        );
        depend.append("id_area", oArea && oArea.id ? oArea.id : null);
        depend.append(
          "id_carpeta_encabezado",
          oCarpeta && oCarpeta.id ? oCarpeta.id : null
        );
        depend.append("empresa", props.userInfo.empresa[0]);
        depend.append(
          "zona",
          props.userInfo.Division_Personal_List[0].descripcion
        );
        depend.append("tipo_documento_GD", tipoDocumentoGD);
      } catch (error) {
        console.log(error);
        toastr.info("Error al subir archivo");
      }
      // Fin lineas para gestor documental
    }

    const oData = {
      nombre: e.target.relativeName.value,
      primer_apellido: e.target.primer_apellido.value,
      segundo_apellido: e.target.segundo_apellido.value,
      apellido_soltera: e.target.apellidoSolt.value,
      identidad: e.target.relativeNIdentidad.value,
      subtipo: relationShip.find(
        (item) => item.id === parseInt(e.target.relativeRelationShip.value)
      ).codigo,
      de: moment().format("YYYY-MM-DD"),
      hasta: moment().format("YYYY-MM-DD"),
      fecha_nacimiento: e.target.relativeBday.value,
      secuencia: edit ? editItem.secuencia : "",
      ciudad_nacimiento: e.target.lugarnaci.value,
      pais_nacimiento: e.target.countyofbirt.value,
      nacionalidad: e.target.countyofbirt.value,
      dependiente: e.target.esDep.checked ? "X" : "",
      genero: e.target.relativeGender.value,
      codigo_empleado: userN,
      empresa_id: userOrg
    };
    dispatch(
      requestChangesDependants(
        oData,
        props.showMessagef,
        edit,
        depend,
        index,
        editItem,
        parseInt(props.type),
        exist,
        setShowModal,
        setValidFechaDoc
      )
    );
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteRelatives(id, index, parseInt(props.type)));
    }
  };

  const { genero, paises } = config.aurora;

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center">
          <Spinner
            animation="border"
            role="status"
            className="d-flex justify-content-center"
          />
        </div>
      ) : data.length > 0 ? (
        <>
          <Card className="border-0">
            <Card.Body className="px-1 px-sm-2">
              <CustomTable columns={columns} data={data} />
            </Card.Body>
          </Card>
        </>
      ) : (
        <Alert variant="info" className="my-4">
          Aún no hay familiares registrados para este empleado, comienza
          agregando algunos
        </Alert>
      )}
      <Modal show={showModal} size="lg" onHide={() => setShowModal(false)}>
        <Form
          onSubmit={props.dpt === 2 ? onSubmit : onSubmitAdmin}
          noValidate
          validated={validated}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {edit ? "Editar ficha de familiar" : "Crear ficha familiar"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {!!formErrors && (
              <Alert variant="danger" className="mt-4 mb-1 mx-3">
                {formErrors}
              </Alert>
            )}
            {!!subNivelesError && (
              <Alert variant="danger" className="mt-4 mb-1 mx-3">
                {subNivelesError}
              </Alert>
            )}
            <Row>
              <Form.Group as={Col} controlId="relativeName">
                <Form.Label className="ml-2">Nombre</Form.Label>
                <Form.Control
                  name="relativeName"
                  className="rounded-pill"
                  required
                  type="text"
                  defaultValue={edit ? editItem.nombre : null}
                  pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ0-9\s]+"
                  placeholder="Nombre completo"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                as={Col}
                sm="12"
                md="12"
                lg="6"
                controlId="primer_apellido"
              >
                <Form.Label className="ml-2">Primer apellido</Form.Label>
                <Form.Control
                  name="primer_apellido"
                  className="rounded-pill"
                  required
                  type="text"
                  defaultValue={edit ? editItem.primer_apellido : null}
                  pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ0-9\s]+"
                  placeholder="Nombre completo"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                as={Col}
                sm="12"
                md="12"
                lg="6"
                controlId="segundo_apellido"
              >
                <Form.Label className="ml-2">Segundo apellido</Form.Label>
                <Form.Control
                  name="segundo_apellido"
                  className="rounded-pill"
                  type="text"
                  defaultValue={edit ? editItem.segundo_apellido : null}
                  pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ0-9\s]+"
                  placeholder="Nombre completo"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                as={Col}
                sm="12"
                md="12"
                lg="6"
                controlId="relativeNIdentidad"
              >
                <Form.Label className="ml-2">Identidad</Form.Label>
                <Form.Control
                  name="relativeNIdentidad"
                  className="rounded-pill"
                  required
                  type="text"
                  pattern="[0-9]{13}"
                  defaultValue={edit ? editItem.identidad : null}
                  placeholder="Identidad"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite una cadena de números de longitud 13
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} controlId="relativeGender">
                <Form.Label className="ml-2">Género</Form.Label>
                <Form.Control
                  as="select"
                  name="relativeGender"
                  className="rounded-pill"
                  required
                  defaultValue={edit ? editItem.genero : null}
                  placeholder="Genero"
                >
                  <option key="No gender selected" value="" selected disabled>
                    -- Seleccione un Genero --
                  </option>
                  {genero.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.nombre}
                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="relativeShip">
                <Row className="align-items-end">
                  <Col sm={relationShipLoader ? "10" : "12"}>
                    <Form.Label className="ml-2">Parentesco</Form.Label>
                    <Form.Control
                      as="select"
                      name="relativeRelationShip"
                      className="rounded-pill"
                      required
                      defaultValue={edit ? editItem.parentesco : null}
                      placeholder="Parentesco"
                    >
                      <option key="No relativeRelationship selected " value="" selected disabled>
                        -- Seleccione un Parentesco --
                      </option>
                      {relationShip.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.nombre}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {relationShipLoader && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group
                as={Col}
                sm="12"
                md="12"
                lg="6"
                controlId="relativeBday"
              >
                <Form.Label className="ml-2">Fecha de nacimiento</Form.Label>
                <Form.Control
                  name="relativeBday"
                  className="rounded-pill"
                  required
                  type="date"
                  defaultValue={edit ? editItem.fecha_nacimiento : null}
                  placeholder="Correo empresarial"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Se requiere un correo valido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                as={Col}
                sm="12"
                md="12"
                lg="6"
                controlId="apellidoSolt"
              >
                <Form.Label className="ml-2">Apellido soltero(a)</Form.Label>
                <Form.Control
                  name="apellidoSolt"
                  className="rounded-pill"
                  type="text"
                  defaultValue={edit ? editItem.apellido_soltera : null}
                  pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ0-9\s]+"
                  placeholder="Apellido soltero(a)"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} sm="12" md="12" lg="6" controlId="lugarnaci">
                <Form.Label className="ml-2">Ciudad de nacimiento</Form.Label>
                <Form.Control
                  name="lugarnaci"
                  className="rounded-pill"
                  required
                  type="text"
                  defaultValue={edit ? editItem.ciudad_nacimiento : null}
                  pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ,.0-9\s]+"
                  placeholder="Ciudad de nacimiento"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="countyofbirt">
                <Form.Label className="ml-2">País de nacimiento</Form.Label>
                <Form.Control
                  as="select"
                  name="countyofbirt"
                  className="rounded-pill"
                  required
                  defaultValue={edit ? editItem.pais_nacimiento : null}
                  placeholder="País de nacimiento"
                >
                  <option key="No selected Country" value="" selected disabled>
                    -- Seleccione un País --
                  </option>
                  {paises.map((item) => (
                    <option key={item.code} value={item.code}>
                      {item.name_es}
                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            {props.dpt === 1 && (
              <Row>
                <Col sm={12} md={6}>
                  <Form.Group controlId="cel">
                    <Form.Label className="ml-2">Teléfono</Form.Label>
                    <Form.Control
                      className="rounded-pill"
                      name="cel"
                      type="tel"
                      pattern="[0-9]{8}"
                      required
                      defaultValue={edit ? editItem.telefono : null}
                      placeholder="Teléfono"
                    />
                    <Form.Control.Feedback type="invalid">
                      **Se requiere un número de teléfono valido
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col sm={12} md={6}>
                  <Form.Group controlId="obs">
                    <Form.Label className="ml-2">Anotaciones</Form.Label>
                    <Form.Control
                      name="obs"
                      className="rounded-pill"
                      type="text"
                      defaultValue={edit ? editItem.anotaciones : null}
                      pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ0-9\s]+"
                      placeholder="Anotaciones"
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            )}
            {props.dpt === 1 && (
              <Form.Group controlId="dependentRelativesAddress">
                <Form.Label className="ml-2">Dirección</Form.Label>
                <Form.Control
                  as="textarea"
                  name="dependentRelativesAddress"
                  required
                  defaultValue={edit ? editItem.direccion : null}
                  pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ0-9\s]+"
                  placeholder="Dirección"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite números y letras
                </Form.Control.Feedback>
              </Form.Group>
            )}
            <Form.Group className="mb-3 ml-2" controlId="esDep">
              <Form.Check
                defaultChecked={
                  String(editItem.dependiente).toLowerCase() === "x"
                    ? true
                    : false
                }
                name="esDep"
                type="checkbox"
                label="Es dependiente económico"
              />
            </Form.Group>
            {(props.dpt === 1 || edit) && (
              <>
                <div className="px-2">
                  <span>Subir documento:</span>
                  <hr className="mt-1" />
                </div>
                <Row>
                  <Form.Group as={Col}>
                    <Form.File id="formcheck-api-regular">
                      <Form.File.Label>Documento</Form.File.Label>
                      <Form.File.Input
                        // accept="image/*"
                        name="documentos"
                        id="documentos"
                        className="py-1"
                        // required={
                        //   (editItem && editItem.archivo_gestor === null) ||
                        //   !edit
                        // }
                        disabled={
                          loadingDocs ||
                          loadingAreas ||
                          loadingCarpetas ||
                          saveDocsLoading ||
                          !(
                            subNiveles &&
                            subNiveles.subNivelTipoDocList.length > 0
                          )
                        }
                        onChange={(e) => {
                          if (e.currentTarget.files.length > 0) {
                            setHabilitarFecha(true);
                            // onChangeFile(e);
                          } else {
                            setHabilitarFecha(false);
                          }
                        }}
                      />
                    </Form.File>
                    
                    <Form.Control.Feedback type="invalid">
                      <ul className="list-unstyled">
                        <li>**Es requerido un archivo de menor peso.</li>
                        <li>
                          **Es requerido un archivo con formato pdf o imagen.
                        </li>
                      </ul>
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Form.Label className="ml-2">Descripción</Form.Label>
                    <Form.Control
                      as="select"
                      name="documentDesc"
                      className="rounded-pill"
                      required={validFechaDoc}
                      placeholder="Descripción del documento"
                      disabled={!habilitarFecha}
                    >
                      <option value="" selected disabled>
                        Seleccione un descripción
                      </option>
                      {subNiveles &&
                        subNiveles.subNivelDescripcionList &&
                        subNiveles.subNivelDescripcionList.map(
                          (item, index) => (
                            <option key={index} value={item.descripcion}>
                              {item.descripcion}
                            </option>
                          )
                        )}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Form.Label className="ml-2">Fecha de entrega</Form.Label>
                    <Form.Control
                      name="fechaDoc"
                      className="rounded-pill"
                      required={validFechaDoc}
                      type="date"
                      placeholder="Descripción"
                      disabled={!habilitarFecha}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
              </>
            )}
            {edit && editItem.archivo_gestor ? (
              <>
                <h6 className="text-muted ml-3">Archivo actual</h6>
                <ul className="list-unstyled">
                  <LinkDescargaGD
                    id={editItem.id}
                    filters={{
                      email: email,
                      id: editItem.archivo_gestor[0].id_documento,
                      llave: editItem.archivo_gestor[0].llave,
                    }}
                    origen={editItem.archivo_gestor[0].origen}
                    cType={editItem.archivo_gestor[0].contentTypeGD}
                  />
                </ul>
              </>
            ) : null}
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => setShowModal(false)}
            >
              Cerrar
            </Button>
            <Button
              className="rounded-pill"
              disabled={saveRelativesLoader}
              variant="primary"
              type="submit"
            >
              {saveRelativesLoader ? (
                <Spinner
                  className="mr-2"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : null}
              Guardar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default forwardRef(DependentRelativesComponent);
